export default "__VITE_ASSET__18fa421c__"